<template>
  <div class="service-width">
    <div>
      <p class="headline mt-7 mb-0">포인트 판매 설정 현황</p>

      <div>
        <v-card v-if="product_count <= 0" outlined class="home-card">
          <v-card-text class="pa-0">
            <div class="float-left">
              <p
                class="home-card-title-text mb-0 mt-5 ml-7 black--text font-weight-black"
              >
                현재 포인트 판매 설정이 되어 있지 않습니다.
              </p>
              <p class="home-card-title-text mb-5 mt-1 ml-7 black--text">
                우리 쇼핑몰만의 포인트를 판매해보세요.
              </p>
            </div>
            <div class="mt-6 mr-7">
              <v-btn
                color="primary"
                hide-details
                style="float:right;"
                depressed
                large
                :disabled="settingButtonDisabled"
                @click="moveSaleSettingPage()"
                >설정하기</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
        <v-card v-else outlined class="home-card">
          <v-card-text class="pa-0">
            <div class="float-left">
              <p
                class="home-card-title-text mb-0 mt-5 ml-7 black--text font-weight-black"
              >
                현재 총 {{ product_count }}개의 포인트 상품을 설정하여
                판매중입니다.
              </p>
              <p class="home-card-title-text mb-5 mt-1 ml-7 black--text">
                '설정/관리' 버튼을 클릭하시면 해당 메뉴로 연결됩니다.
              </p>
            </div>
            <div class="mt-6 mr-7">
              <v-btn
                color="primary"
                hide-details
                style="float:right;"
                depressed
                large
                :disabled="settingButtonDisabled"
                @click="moveSaleSettingPage()"
                >설정/관리</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <div
      v-for="(sales, index) in sales_status"
      :key="index"
      class="mt-3 d-inline-block"
    >
      <p v-if="index == 0" class="headline mt-7 mb-0">오늘의 판매 현황</p>
      <p v-else-if="index == 1" class="headline mt-7 mb-0">
        최근 1달 판매 현황
      </p>
      <p v-else class="headline mt-7 mb-0">누적 판매 현황</p>

      <div class="float-left">
        <v-card outlined class="home-sales-status-card mr-3">
          <v-card-text class="pa-0">
            <div class="float-left">
              <p class="home-sales-status-card-title">
                포인트 상품 판매 건수
              </p>
              <p
                class="headline font-weight-light font-weight-bold mb-3 mt-3 ml-5 pt-1 black--text"
              >
                {{ sales.sales_count | comma }}
              </p>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="float-left">
        <v-card outlined class="home-sales-status-card mr-3">
          <v-card-text class="pa-0">
            <div class="float-left">
              <p class="home-sales-status-card-title">
                포인트 상품 판매금액
              </p>
              <p
                class="headline font-weight-light font-weight-bold mb-3 mt-3 ml-5 pt-1 black--text"
              >
                {{ sales.sales_amount | comma }}
              </p>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="float-left">
        <v-card outlined class="home-sales-status-card">
          <v-card-text class="pa-0">
            <div class="float-left">
              <p class="home-sales-status-card-title">
                지급된 포인트 금액
              </p>
              <p
                class="headline font-weight-light font-weight-bold mb-3 mt-3 ml-5 pt-1 black--text"
              >
                {{ sales.charged_points | comma }}
              </p>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
let dayjs = require("dayjs");

import "@/assets/style/home.css";
import M from "@/libs/mapping.js";
import Filters from "@/libs/filters.js";

export default {
  data: () => {
    return {
      M,
      product_count: 0,
      settingButtonDisabled: true,
      sales_status: [],
    };
  },
  methods: {
    // 상품 개 수 조회
    getProductCount: async function() {
      try {
        let result = await M.api(M.entry("/get/mileage/count"));
        this.product_count = result.count;
      } catch (e) {
        //
      }
    },
    // 판매 현황 조회
    getProductSalseStatus: async function() {
      const today = dayjs();
      let now = today.format("YYYY-MM-DD");
      let before_month = today.subtract("1", "month").format("YYYY-MM-DD");
      let searchDateArray = [
        // 오늘의 판매 현황
        { sales_from: now, sales_to: now },
        // 최근 1달 판매 현황
        { sales_from: before_month, sales_to: now },
        // 누적 판매 현황
        { sales_from: "2021-01-08", sales_to: now },
      ];
      for (let i = 0; i < searchDateArray.length; i++) {
        try {
          let result = await M.api(
            M.entry("/get/mileage/sales"),
            searchDateArray[i]
          );

          this.sales_status.push(result);
        } catch (e) {
          alert("설정 조회 실패했습니다.\n새로고침(F5)하여 재확인해주세요.");
          this.$parent.loadCompleted();
          return;
        }
      }
      this.$parent.loadCompleted();
    },

    // data 초기화
    resetData: function() {
      Object.assign(this.$data, this.$options.data());
    },
    // 기간 만료시 버튼 막기
    buttonDisabled: function() {
      if (this.$store.state.mode == "enabled") {
        this.settingButtonDisabled = false;
      }
    },
    moveSaleSettingPage: function() {
      this.$router.push({
        path: `/mileage/${this.$store.state.mallId}/sales_setting`,
      });
    },
  },
  filters: Filters,
  created: async function() {
    // data 초기화
    this.resetData();
    // 상품 개수 조회
    await this.getProductCount();
    // 핀메 현황 조회
    await this.getProductSalseStatus();
  },
  mounted: function() {
    // 기간 만료시 버튼 막기
    this.buttonDisabled();
  },
};
</script>
